/* eslint-disable no-console */
import Env from './Env';

// calling `new Env()` here b/c this imports directly from the Env file instead of from the shared utils file,
// to avoid circular dependency, so the class needs to be instantiated.
const env = new Env();

const Logger = (() => {
    const Log = (messages, logLevel = 'Info', dev = false) => {
        if (messages.length === 0) {
            return;
        }
        if (messages.length === 1) {
            if (logLevel === 'Error') {
                console.error(messages[0]);
            }
            if (logLevel === 'Warn') {
                console.warn(messages[0]);
            }
            if (logLevel === 'Info') {
                if (dev) {
                    console.log('[DEV]', messages[0]);
                } else {
                    console.log(messages[0]);
                }
            }
            return;
        }
        const otherMessages = messages.slice(1);
        if (logLevel === 'Error') {
            console.error(messages[0], otherMessages);
        }
        if (logLevel === 'Warn') {
            console.warn(messages[0], otherMessages);
        }
        if (logLevel === 'Info') {
            if (dev) {
                console.log('[DEV]', messages[0], otherMessages);
            } else {
                console.log(messages[0], otherMessages);
            }
        }
    };

    const Info = (...messages) => {
        Log(messages, 'Info');
    };

    const w = (...messages) => {
        Log(messages, 'Warn');
    };

    const e = (...messages) => {
        let shouldLog = true;
        Object.values(messages).forEach((msg) => {
            if (msg?.message) {
                const { message } = msg;
                if (typeof message !== 'string') {
                    return;
                }

                if (message.includes('Cancelled')) {
                    shouldLog = false;
                }
            } else {
                if (typeof msg !== 'string') {
                    return;
                }
                if (msg.includes('Cancelled')) {
                    shouldLog = false;
                }
            }
        });
        if (shouldLog) {
            Log(messages, 'Error');
        }
    };

    const DevLog = (...messages) => {
        if (env.isLocal()) {
            Log(messages, 'Info', true);
        }
    };

    const tmp = (...messages) => {
        messages.unshift('[TMP]');
        Log(messages, 'Info');
    };

    /* aliases */
    const Dev = DevLog;
    const dev = DevLog;
    const info = Info;
    const i = Info;
    const warn = w;
    const error = e;

    return {
        Dev,
        dev,
        DevLog,
        e,
        error,
        i,
        Info,
        info,
        tmp,
        w,
        warn
    };
})();

export default Logger;
